<template>
    <div 
        class="carousel-container" 
        ref="carouselContainer"
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave"
    >
        <!-- 轮播内容容器 -->
        <div class="carousel-wrapper"
            :style="{ transform: `translateX(-${currentIndex * 100}%)`, transition: `transform ${transitionDuration}ms ease` }">
            <!-- 插槽：父组件传入的每一页内容 -->
            <div class="carousel-slide">
                <div class="strategy-section">
                    <div class="strategy-content">
                        <h2 class="strategy-title">
                            <span class="highlight">{{ $t('home.carousel.hedge') }}</span>{{
                                $t('home.carousel.arbitrage') }}
                        </h2>
                        <ul class="strategy-list">
                            <li class="strategy-item">
                                <h3>{{ $t('home.carousel.MarketPremise') }}</h3>
                                <p>{{ $t('home.carousel.MarketPremise_1') }}</p>
                            </li>
                            <li class="strategy-item">
                                <h3>{{ $t('home.carousel.build') }}</h3>
                                <p>{{ $t('home.carousel.build_1') }}</p>
                            </li>
                            <!-- <li class="strategy-item">
                                <h3>{{ $t('home.carousel.mean') }}</h3>
                                <p>{{ $t('home.carousel.mean_1') }}</p>
                            </li> -->
                        </ul>
                        <router-link to="/blog-single-column" class="view-more"
                            style="display: flex;align-items: center;margin-top: 90px;">
                            <span>{{ $t('home.carousel.view') }}</span><img style="width: 14px; margin-left: 3px;"
                                src="@/assets/images/icons/icon_home_more@2x.png" alt=""></router-link>

                    </div>

                    <div class="strategy-image">
                        <!-- 图片占位区域，实际项目中替换为img标签 -->
                        <Polyline x-axis-first-label="2023-01" x-axis-last-label="2025-12" value-field="sales"
                            :data-list="customData" :top-right-text="$t('annualized')" />
                        <!-- <div style="display: flex;justify-content: center;width: 100%;color: #f5f5f5;opacity: 0.7;margin-top: -20px;">{{ $t('home.schematicDiagram') }}</div> -->
                    </div>
                </div>
            </div>
            <div class="carousel-slide">
                <div class="strategy-section">
                    <div class="strategy-content">
                        <h2 class="strategy-title">
                            <span class="highlight">{{ $t('home.carousel.foreignExchange') }}</span>{{
                                $t('home.carousel.arbitrage_1') }}
                        </h2>
                        <ul class="strategy-list">
                            <li class="strategy-item">
                                <h3>{{ $t('home.carousel.collect') }}</h3>
                                <p>{{ $t('home.carousel.collect_1') }}</p>
                            </li>
                            <li class="strategy-item">
                                <h3>{{ $t('home.carousel.factor') }}</h3>
                                <p>{{ $t('home.carousel.factor_1') }}</p>
                            </li>
                            <!-- <li class="strategy-item">
                                <h3>{{ $t('home.carousel.combination') }}</h3>
                                <p>{{ $t('home.carousel.combination_1') }}</p>
                            </li> -->
                        </ul>
                        <router-link to="/blog-single-column" class="view-more"
                            style="display: flex;align-items: center;margin-top: 70px;">
                            <span>{{ $t('home.carousel.view') }}</span><img style="width: 14px; margin-left: 3px;"
                                src="@/assets/images/icons/icon_home_more@2x.png" alt=""></router-link>
                    </div>
                    <div class="strategy-image">
                        <!-- 图片占位区域，实际项目中替换为img标签 -->
                            <Polyline x-axis-first-label="2024-3" x-axis-last-label="2025-12" value-field="sales"
                            :data-list="customData_tow" :top-right-text="$t('drawdown')" />
                        <!-- <div style="display: flex;justify-content: center;width: 100%;color: #f5f5f5;opacity: 0.7;margin-top: -20px;">{{ $t('home.schematicDiagram') }}</div> -->
                        <!-- <img style="width: 100%;" src="@/assets/images/bg/img_shouye_waihui@2x.png" alt=""> -->
                    </div>
                </div>
            </div>
        </div>

        <!-- 左右切换按钮 -->
        <!-- <button 
        class="carousel-btn prev-btn" 
        @click="prevSlide"
        :disabled="isAnimating || slidesCount <= 1"
        aria-label="上一页"
        v-if="showButtons"
      >
        &lt;
      </button>
      <button 
        class="carousel-btn next-btn" 
        @click="nextSlide"
        :disabled="isAnimating || slidesCount <= 1"
        aria-label="下一页"
        v-if="showButtons"
      >
        &gt;
      </button> -->

        <!-- 指示器（圆点） -->
        <div class="carousel-indicators" v-if="showIndicators && slidesCount > 1">
            <span class="indicator-dot" v-for="index in slidesCount" :key="index"
                :class="{ 'active': currentIndex === index - 1 }" @click="goToSlide(index - 1)"
                :aria-label="`切换到第${index}页`"></span>
        </div>
    </div>
</template>

<script>
import Polyline from './polyline'
import PolylineOne from './polyline_1'
export default {
    name: 'Carousel',
    components: {
        Polyline
    },
    props: {
        // 轮播的总页数，由父组件传入
        slidesCount: {
            type: Number,
            required: true,
            validator: (value) => value >= 1
        },
        // 自动播放时长（毫秒，0表示不自动播放）
        autoPlay: {
            type: Number,
            default: 3000
        },
        // 切换动画时长（毫秒）
        transitionDuration: {
            type: Number,
            default: 500
        },
        // 是否显示指示器
        showIndicators: {
            type: Boolean,
            default: true
        },
        // 是否显示切换按钮
        showButtons: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            currentIndex: 0,
            isAnimating: false,
            autoPlayTimer: null,
            customData: [
                { label: '', sales: 50 },
                { label: '', sales: 57 },
                { label: '', sales: 65 },
                { label: '', sales: 78 },
                { label: '', sales: 85},
                { label: '', sales: 99 },
                { label: '', sales: 108 },
                { label: '', sales: 125 },
                { label: '', sales: 142 },
                { label: '', sales: 160 },
                { label: '', sales: 188 },
                { label: '', sales: 210},
            ],
            customData_tow: [
                { label: '1月', sales: 50 },
                { label: '2月', sales: 80 },
                { label: '3月', sales: 76.8 },
                { label: '4月', sales: 120 },
                { label: '5月', sales: 115.2},
                { label: '6月', sales: 150 },
                { label: '7月', sales: 200 },
            ]
        };
    },
    watch: {
        autoPlay: {
            handler(newVal) {
                this.stopAutoPlay();
                if (newVal > 0 && this.slidesCount > 1) {
                    this.startAutoPlay();
                }
            },
            immediate: true
        },
        slidesCount(newVal) {
            // 当页数变化时，重置索引并重启自动播放
            this.currentIndex = 0;
            this.stopAutoPlay();
            if (this.autoPlay > 0 && newVal > 1) {
                this.startAutoPlay();
            }
        }
    },
    mounted() {
        if (this.autoPlay > 0 && this.slidesCount > 1) {
            this.startAutoPlay();
        }
    },
    beforeDestroy() {
        this.stopAutoPlay();
    },
    methods: {
        generateTimeData(externalValues = []) {
            // 1. 优先计算当前时间，再减去1个月作为时间轴的终点（核心修改点）
            const now = new Date();
            const endDate = new Date(now);
            // 步骤1：先减去1个月
            endDate.setMonth(endDate.getMonth() - 1);
            // 步骤2：将日期设为1号，避免跨月计算时的日期溢出（如31号减2个月到2月的问题）
            endDate.setDate(1);

            // 2. 生成12个时间节点（从「当前-1个月」往前倒推，每2个月一个，覆盖两年）
            const timePoints = [];
            let currentDate = new Date(endDate);

            // 先从「当前-1个月」倒推生成12个节点（顺序：当前-1个月 → 两年前+1个月）
            for (let i = 0; i < 12; i++) {
                // 格式化时间为 YYYY-MM（与图表tooltip/轴标签兼容）
                const year = currentDate.getFullYear();
                const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // 月份从0开始，补前导0
                timePoints.push(`${year}-${month}`);

                // 每次往前倒推2个月
                currentDate.setMonth(currentDate.getMonth() - 2);
            }

            // 反转数组，让时间顺序变为：两年前+1个月 → 当前-1个月（适配图表X轴从左到右的展示逻辑）
            timePoints.reverse();

            // 3. 结合外部传入的value生成最终数组（兼容长度：不足补0，超出截断）
            const result = timePoints.map((label, index) => {
                const value = externalValues[index] !== undefined ? externalValues[index] : 0;
                return { label, value };
            });

            return result;
        },
        startAutoPlay() {
            // 先清除旧定时器，避免叠加
            this.stopAutoPlay();
            this.autoPlayTimer = setInterval(() => {
                this.nextSlide();
            }, this.autoPlay);
        },
        stopAutoPlay() {
            if (this.autoPlayTimer) {
                clearInterval(this.autoPlayTimer);
                this.autoPlayTimer = null;
            }
        },
        // 新增：鼠标移入暂停轮播
        handleMouseEnter() {
            this.stopAutoPlay();
        },
        // 新增：鼠标移出恢复轮播
        handleMouseLeave() {
            // 仅当自动播放开启且轮播页数大于1时恢复
            if (this.autoPlay > 0 && this.slidesCount > 1) {
                this.startAutoPlay();
            }
        },
        prevSlide() {
            if (this.isAnimating || this.slidesCount <= 1) return;
            this.isAnimating = true;
            this.currentIndex = (this.currentIndex - 1 + this.slidesCount) % this.slidesCount;
            this.resetAnimationLock();
        },
        nextSlide() {
            if (this.isAnimating || this.slidesCount <= 1) return;
            this.isAnimating = true;
            this.currentIndex = (this.currentIndex + 1) % this.slidesCount;
            this.resetAnimationLock();
        },
        goToSlide(index) {
            if (this.isAnimating || this.currentIndex === index || this.slidesCount <= 1) return;
            this.isAnimating = true;
            this.currentIndex = index;
            this.resetAnimationLock();
        },
        resetAnimationLock() {
            // 在动画结束后解锁
            setTimeout(() => {
                this.isAnimating = false;
            }, this.transitionDuration);
        }
    }
};
</script>

<style lang="scss" scoped>
.strategy-section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 60px 40px;

    color: #fff;
    font-family: 'Microsoft Yahei', sans-serif;
    width: 100%;

    .strategy-content {
        flex: 1;

        .strategy-title {
            font-size: 48px;
            margin-bottom: 30px;

            .highlight {
                color: #ffc107;
            }
        }

        .strategy-list {
            list-style: none;
            padding: 0;
            margin-bottom: 25px;

            .strategy-item {
                margin-bottom: 20px;

                h3 {
                    font-size: 18px;
                    margin-bottom: 8px;
                    color: #F5F5F5;
                }

                p {
                    font-size: 14px;
                    color: #F5F5F5;
                    line-height: 1.5;
                    opacity: 0.7;
                }
            }
        }

        .view-more {
            font-size: 14px;
            color: #ffc107;
            text-decoration: none;
            transition: color 0.3s;

            &:hover {
                color: #ffd54f;
            }
        }
    }

    .strategy-image {
        flex: 1;

        .image-placeholder {
            width: 100%;
            height: 300px;
            background-color: #2c3e50;
            border: 1px dashed #ccc;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #aaa;
            font-size: 14px;

        }
    }
}

/* 轮播容器 */
.carousel-container {
    position: relative;
    width: 100%;
    overflow: hidden;
    /* 新增：鼠标移入显示指针，提升交互体验 */
    cursor: default;

    /* 轮播内容容器 */
    .carousel-wrapper {
        display: flex;
        height: 100%;
        transition: transform 500ms ease;
        /* 默认过渡效果 */
    }

    /* 单个轮播页 */
    .carousel-slide {
        flex-shrink: 0;
        height: 100%;
        width: 100%;
        /* 内容由父组件决定，这里可以设置一些通用样式 */
        display: flex;
        align-items: center;
        justify-content: center;
    }

    /* 切换按钮 */
    .carousel-btn {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: rgba(0, 0, 0, 0.5);
        color: #fff;
        font-size: 18px;
        border: none;
        cursor: pointer;
        z-index: 10;
        transition: background-color 0.3s ease;
        outline: none;

        &:hover {
            background-color: rgba(0, 0, 0, 0.8);
        }

        &:disabled {
            opacity: 0.3;
            cursor: not-allowed;
        }

        &.prev-btn {
            left: 20px;
        }

        &.next-btn {
            right: 20px;
        }
    }

    /* 指示器容器 */
    .carousel-indicators {
        position: absolute;
        bottom: 0px;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        gap: 8px;
        z-index: 10;

        /* 指示器圆点 */
        .indicator-dot {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: #313d46;
            cursor: pointer;
            transition: all 0.3s ease;

            /* 激活状态 */
            &.active {
                width: 30px;
                background-color: #ffd200;
                border-radius: 5px;
                /* 激活时变成长条形 */
            }
        }
    }
}

@media (max-width: 720px) {
    .strategy-section {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
    }
}
</style>